<template>
  <div class="animated fadeIn list-of-cashflow">
    <b-card>
      <div slot="header">REPORT CASH/BANK BOOK DETAIL
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="6">
          <b-input-group >
              <b-input-group-prepend><label>Cash/bank Account</label></b-input-group-prepend>
              <b-form-input readonly v-model="model.namabank" @keyup.13.native="lkuBankaccountShow=true" :state="!$v.model.kodebank.$error"></b-form-input>
              <b-input-group-append>
                  <b-btn text="Button" @click="lkuBankaccountShow=true">
                      <i class="fa fa-search"></i>
                  </b-btn>
              </b-input-group-append>
              <b-input-group-append><span class="pt-2 ml-2 mr-1">GL Account#</span></b-input-group-append>
              <b-input-group-append>
                  <span class="input-group-text" style="min-width:150px;">{{model.kodeacc}}</span>
              </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-input-group >
            <b-input-group-prepend><span class="pt-2 mr-1">Trx. Date Range</span></b-input-group-prepend>
            <b-form-input v-model="model.tgl1" type="date" ></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="model.tgl2" type="date" ></b-form-input>
            <b-input-group-append ><b-button class="ml-2 btn btn-success mr-2" @click="getData()" > <i class="fa fa-play"></i> Process</b-button></b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
          <template v-slot:header v-if="(filterShow=='Hide')">          
            <b-row >
                <b-col lg="3">
                  <b-input-group size="sm" class="mt-1">
                    <b-input-group-prepend><span class="pt-1 mr-1" >FILTER</span></b-input-group-prepend>
                    <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                        ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                    </b-input-group-append>
                    </b-input-group>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>

                </b-col> 
                <b-col lg="9">
                  <b-form-group
                    label="FILTER ON :"
                    label-cols-sm="1"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="uraian">Description</b-form-checkbox>
                      <b-form-checkbox value="paymethod">Payment Method</b-form-checkbox>
                      <b-form-checkbox value="terimadari">From/to Payee </b-form-checkbox>
                      <b-form-checkbox value="trxgroups">Trx.Group (AP/AR,..)</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
            </b-row>
        </template>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblLcy.fields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filterInput"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
              <template v-slot:cell(tanggal)="data">
                  {{ data.item.tanggal | moment("DD-MMM-YYYY") }}
                  <!-- <span v-if="(data.item.tanggal)">{{ data.item.tanggal | moment("DD-MMM-YYYY") }}</span> -->
              </template>
                <template v-slot:cell(bank_in)="data">
                      {{ data.item.bank_in | numFormat('0,0.00') }}
                </template>
                <template v-slot:cell(bank_out)="data">
                      {{ data.item.bank_out | numFormat('0,0.00') }}
                </template>
                <template v-slot:cell(sakhir)="data">
                      {{ data.item.sakhir | numFormat('0,0.00') }}
                </template>
                <template v-slot:cell(valas_in)="data">
                      {{ data.item.valas_in | numFormat('0,0.00') }}
                </template>
                <template v-slot:cell(valas_out)="data">
                      {{ data.item.valas_out | numFormat('0,0.00') }}
                </template>
                <template v-slot:cell(sakhirOri)="data">
                      {{ data.item.sakhirOri | numFormat('0,0.00') }}
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col lg="6">
                    <b-row >
                      <b-col cols="8">
                        <div class="ml-1">
                          Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                          to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                          of {{tblLcy.total}} entries,   <span class="mr-1">limit per page :</span> 
                          <input type="number" style="width:80px;" v-model="tblLcy.limit" v-b-tooltip.hover :title="`${tblLcy.limit} records`" />
                        </div>
                        <b-pagination  class="ml-1" 
                          align="left"
                          :total-rows="tblLcy.total"
                          :per-page="tblLcy.limit"
                          v-model="tblLcy.page"
                        ></b-pagination>
                      </b-col>
                      <b-col cols="4">            
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-2">
                          <b> {{ filterShow }}</b>  Filter
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col lg="6">
                  <b-form-row>
                    <b-col md="2">
                      <b-form-group label="Total Debit" >
                          <my-number class="form-control text-right" v-model="totalValas_in" :precision="2" disabled></my-number>
                      </b-form-group>                  
                    </b-col>
                    <b-col md="2">
                        <b-form-group label="Total Credit" >
                            <my-number class="form-control text-right" v-model="totalValas_out" :precision="2" disabled></my-number>
                        </b-form-group>                  
                    </b-col>
                    <b-col md="2">
                        <b-form-group label="End. Balance" >
                            <my-number class="form-control text-right" v-model="sakhirOri" :precision="2" disabled></my-number>
                        </b-form-group>                  
                    </b-col>
                    <b-col md="2">
                      <b-form-group label="Total Debit (LCY)" >
                          <my-number class="form-control text-right" v-model="totalBank_in" :precision="2" disabled></my-number>
                      </b-form-group>                  
                    </b-col>
                    <b-col md="2">
                        <b-form-group label="Total Credit (LCY)" >
                            <my-number class="form-control text-right" v-model="totalBank_out" :precision="2" disabled></my-number>
                        </b-form-group>                  
                    </b-col>
                    <b-col md="2">
                        <b-form-group label="End. Balance (LCY)" >
                            <my-number class="form-control text-right" v-model="sakhir" :precision="2" disabled></my-number>
                        </b-form-group>                  
                    </b-col>
                  </b-form-row>
                </b-col>
            </b-row>
      </b-card>

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
        <lku-bankaccount @click="onSelectLkuBankaccount" :formdata="lkuBankaccountData" aktif=1></lku-bankaccount>
    </b-modal>        

  </div>
</template>

<style lang="scss" scoped>
 
</style>

<script>
import moment from 'moment';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import cashflow from "../../apis/cashflow";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        kodebank: { required },
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
      lkuBankaccountData:{},
      lkuBankaccountShow: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model: {kodebank:'',tgl1:'',tgl2:''},
      bankCashAcc: [],
      rptLines : [],
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "tanggal",
            label: "Trx. Date",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nomor",
            label: "Trx. Number",
            sortable: true
          },
        {
          key: "uraian",
          label: "Description",
        },
        {
          key: "terimadari",
          label: "to/from",
          sortable: true
        },
        {
          key: "paymethod",
          label: "Pay Method",
          sortable: true
        },
        {
          key: "nomor_cek",
          label: "Giro/Cheque #",
          sortable: true
        },
        {
          key: "createby",
          label: "Create By",
          sortable: true
        },
        {
          key: "valas_in",
          label: "Debit",
          thStyle: "width:90px",
          thClass: "text-right",
          tdClass: "text-right"
        },
        {
          key: "valas_out",
          label: "Credit",
          thStyle: "width:90px",
          thClass: "text-right",
          tdClass: "text-right"
        },
        {
          key: "sakhirOri",
          label: "End Balance",
          thStyle: "width:90px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "bank_in",
          label: "Debit (LCY)",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right"
        },
        {
          key: "bank_out",
          label: "Credit (LCY)",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right"
        },
        {
          key: "sakhir",
          label: "End Balance  (LCY)",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        ]
      },
      filterShow:'Show',
      filter: null,
      filterInput: null,
      filterOn: [],   
      totalBank_in:0, totalBank_out:0, sakhir:0,
      totalValas_in:0, totalValas_out:0, sakhirOri:0
    };
  },
  components: {Loading,lkuBankaccount, myNumber},
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },  
  watch:{
    filterShow: function(newval) {
      setTimeout(() => {
              this.filter=''
      }, 200);
    },
    filter: function(newval) {
      // this.isBusy=true;
      setTimeout(() => {
            this.filterInput=newval;
      }, 800);
    },
  },   
  created: async function(){
      // this.bankCashAcc = await cashflow.bankaccount();
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.model.tgl1=this.$store.state.user.tglaktif;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');

  },  
  methods: {
    onSelectLkuBankaccount(lkuData) {
        this.lkuBankaccountData=lkuData;
        this.lkuBankaccountShow=false;
        this.model.kodebank=lkuData.selected.kode;
        this.model.matauang=lkuData.selected.matauang;
        this.model.namabank=lkuData.selected.namabank;
        this.model.namaacc=lkuData.selected.namabank || '';
        this.model.nomorrek=lkuData.selected.nomorrek;
        this.model.kodeacc=lkuData.selected.kodeacc;
        this.lkuBankaccountShow=false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      // this.totalBank_in = filteredItems.reduce((a, b) => a + b.bank_in, 0);
      // this.totalBank_out = filteredItems.reduce((a, b) => a + b.bank_out, 0);
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
        this.rptLines = await cashflow.bankcashbookdetail(this.model);
        this.tblLcy.total = this.rptLines.length;        
        // this.totalBank_in = this.rptLines.reduce((a, b) => a + b.bank_in, 0);
        // this.totalBank_out = this.rptLines.reduce((a, b) => a + b.bank_out, 0);
        this.totalBank_in = this.rptLines[this.tblLcy.total-1].bank_in;
        this.totalBank_out = this.rptLines[this.tblLcy.total-1].bank_out;
        this.totalValas_in = this.rptLines[this.tblLcy.total-1].valas_in;
        this.totalValas_out = this.rptLines[this.tblLcy.total-1].valas_out;
        this.sakhir = this.rptLines[this.tblLcy.total-1].sakhir;
        this.sakhirOri = this.rptLines[this.tblLcy.total-1].sakhirOri;
        this.isLoading=false;      
       }
    },

    printJv: async function(data){
        this.showConfirmAction=false;
        this.showList=false;
       if ((data.nomor !== 'BEGINING') && (data.nomor !== '')) {
          this.isLoading=true;
          try {
              this.reportUrl= await cashflow.printjv(data);
              this.isLoading=false;    
              if (this.$isMobile()){
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              } else {
                this.showReport=true;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } 
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                this.reportUrl= await cashflow.bankcashbookdetailprint(this.model);
                this.showReport=true;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await cashflow.bankcashbookdetailexport(this.model);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("/treasury/home");
    }
  }
};
</script>
